// Typelizer digest e0ecf43536b1d4778882083259813410
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/sales_documents/:sales_document_id/preview */
  show: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/preview', params, options),
    method: 'get',
  }),

  /** POST /c/:company_id/sales_documents/:sales_document_id/preview */
  create: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/preview', params, options),
    method: 'post',
  }),
}
